import Resource from './Resource';

export default class CurrentSchoolYear extends Resource {
	constructor(options={}) {
		let {
			route = 'school-years/current',
			query = {}
		} = options;

		let config = {
			route: route,
			query: query
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
